import { AfterViewInit, Directive, OnDestroy, inject } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Subscription } from 'rxjs';

@Directive({ selector: '[appCdAutocompletePosition]' })
export class CdAutocompletePositionDirective implements AfterViewInit, OnDestroy {
  private readonly matAutocompleteTrigger = inject(MatAutocompleteTrigger);

  private readonly subscription = new Subscription();

  public constructor() {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  public ngAfterViewInit(): void {
    const autocomplete = this.matAutocompleteTrigger.autocomplete;
    if (autocomplete == null) {
      return;
    }

    // Recalculate position right after open; first render can shift after option list/layout settles.
    this.subscription.add(
      autocomplete.opened.subscribe(() => {
        setTimeout(() => this.matAutocompleteTrigger.updatePosition());
      })
    );
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollEvent, true);
    this.subscription.unsubscribe();
  }

  private scrollEvent = (): void => {
    if (this.matAutocompleteTrigger == null) {
      return;
    }
    if (this.matAutocompleteTrigger.panelOpen) {
      this.matAutocompleteTrigger.updatePosition();
    }
  };
}
